<div class="disease-multidisciplinary-wrapper container-fluid py-5">
    <div class="container-xxxl py-lg-4">
        <div class="container-fluid pb-32">
            <div class="row">
                <h2 class="section-heading text-blue border-blue">{{ textHeader }}</h2>
            </div>
        </div>
        <div class="row align-items-start gx-4 gy-4 gy-xl-0">
            <div class="col-12 col-xl-6 pe-xl-5 d-print-none">
                <img class="diagnostic-section-image img-fluid rounded-3 w-100" [src]="imgPath + bodyKA.images[0]?.url + '-600.webp'" [alt]="bodyKA.images[0]?.altText" />
            </div>

            <div class="col-12 col-xl-6 ps-xl-5">
                <h3 class="subheading fw-bold mb-3" [innerHTML]="bodyKA.title"></h3>
                <p class="fs-6 fs-lg-18" embeddedHTML [innerHTML]="bodyKA.bodyText"></p>
                <p class="fs-6 fs-lg-18" embeddedHTML [innerHTML]="pediatricsKA.bodyText" *ngIf="pediatricsKAShouldShow"></p>
            </div>
        </div>
    </div>
</div>
